/*
 * @Author: YuanYuan
 * @Date: 2024-02-07 10:39:33
 * @LastEditTime: 2025-12-12 14:14:54
 * @description: 用量查询路由定义
 */
import i18n from '@/i18n'

export default [
  {
    path: '/usage',
    meta: {
      title: i18n.t('menu.usageQuery'),
      leftMenuCode: 'Configurations'
    },
    component: () => import('@/views/usage/index.vue')
  }
]